import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X5LessonSnapshot} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeactivateSnapshotStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly snapshot: X5LessonSnapshot) {
    makeObservable(this);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x5lessonSnapshot.deactivate(this.snapshot.Id);
  }
}
